import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Dialog } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueResource from 'vue-resource'
// 按需导入 qrcode 库中的方法

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(VueResource)
Vue.use(Dialog)
Vue.use(ElementUI)

// 由于 qrcode 不是 Vue 插件，不需要使用 Vue.use()

new Vue({
  render: h => h(App),
}).$mount('#app')